import { Column } from './types'

export const isStatusColumn = (column?: Column): boolean =>
  column?.type === 'Projects::Columns::System' && column.key === 'status'
